import {
    AnnotatedIllustration,
    Carousel,
    Exercise,
    GhostButton,
    LabelBody,
    LabelDisplay2,
    SecondaryButton,
    Spacer,
    SwirlyBox,
} from '../../components';
import {
    Module1S1Exercise1Illustration1,
    Module1S1Exercise1Illustration2,
    Module1S1Exercise1Illustration3,
    Module1S1Exercise1Illustration4,
} from '../../icons';
import { ExerciseStatus } from '../../interfaces';
import { ExerciseViewProps } from '../exercises';

export function Module1S1Exercise1({ onContinue }: ExerciseViewProps) {
    return (
        <Exercise title="Hav ubehag med på rejsen">
            <LabelDisplay2 className="my-10">
                Se her, hvad det vil sige at have ubehag med på rejsen
            </LabelDisplay2>
            <LabelBody>
                Vi kan ikke altid kontrollere vores negative tanker og følelser.
                Alternativet er, at vi skaber plads til dem. Det betyder ikke,
                at vi skal kunne lide dem, men bare være villige til at de er
                tilstede. At lade dem være tilstede kan se sådan her ud.
            </LabelBody>
            <Carousel
                className="my-30"
                pages={[
                    <AnnotatedIllustration
                        image={<Module1S1Exercise1Illustration1 />}
                        title="Observer dem og vær nysgerrig"
                    />,
                    <AnnotatedIllustration
                        image={<Module1S1Exercise1Illustration2 />}
                        title="Træk vejret roligt ind i dem"
                    />,
                    <AnnotatedIllustration
                        image={<Module1S1Exercise1Illustration3 />}
                        title="Hold dem let og med omsorg"
                    />,
                    <AnnotatedIllustration
                        image={<Module1S1Exercise1Illustration4 />}
                        title="Bær dem imens du laver andre ting"
                    />,
                ]}
            />
            <LabelBody>
                Når vi bruger mindre tid på at kontrollere vores følelser og
                tanker, har vi mere plads til at gøre de ting, vi har lyst til.
            </LabelBody>
            <SwirlyBox className="my-30">
                Er du med på at prøve at eksperimentere med det?
            </SwirlyBox>
            <Spacer />
            <SecondaryButton
                className="mb-20"
                onClick={() =>
                    onContinue({
                        status: ExerciseStatus.Completed,
                        goToNext: true,
                    })
                }
            >
                Ja, det vil jeg gerne
            </SecondaryButton>
            <GhostButton
                onClick={() =>
                    onContinue({
                        status: ExerciseStatus.Completed,
                        goToNext: false,
                    })
                }
            >
                Vender tilbage senere
            </GhostButton>
        </Exercise>
    );
}
